import { Pipe, PipeTransform } from '@angular/core';
import { ValidationRequestType } from '@app/features/contracts/validation/validation-request.model';

function assertNever(value: never): never {
  throw new Error(`Valeur inattendue : ${value}`);
}

@Pipe({
  name: 'validationRequestTypeLabel',
})
export class ValidationRequestTypeLabelPipe implements PipeTransform {
  transform(requestType: ValidationRequestType): string {
    switch (requestType) {
      case 'REX_VALIDATION':
        return 'REX';
      case 'DA_VALIDATION':
        return 'Directeur Agence';
      case 'DP_VALIDATION':
        return 'Directeur Production';
      case 'RRH_VALIDATION':
        return 'Responsable RH';
      case 'DRH_VALIDATION':
        return 'DRH';
      default: {
        return assertNever(requestType);
      }
    }
  }
}
